import React from "react";
import logo from "../../assets/adminlogo.png";
import { GoPerson } from "react-icons/go";
import { FaRegBell } from "react-icons/fa6";
import { BsBoxArrowLeft } from "react-icons/bs";
import { IoIosMenu } from "react-icons/io";

const Header = () => {
  return (
    <>
      <div className="flex justify-between items-center px-4 py-3">
        <img src={logo} className="h-7 md:h-10" alt="" />
        <div className="md:flex hidden items-center gap-3">
          <GoPerson className="p-1 border rounded-md text-black" size={40} />
          <FaRegBell className="p-1 border rounded-md text-black" size={40} />
          <button className="flex items-center gap-2 border rounded-md p-2 bg-red-600 text-white font-semibold">
            <BsBoxArrowLeft /> Logout
          </button>
        </div>
        <IoIosMenu className="md:hidden" size={35} />
      </div>
      <hr />
    </>
  );
};

export default Header;
